import React from "react";
import { motion } from "framer-motion";


const bannerVariant = {
  hidden: {
    opacity: 0,
    scale: 1.08,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 1.8,
      ease: "easeOut",
    },
  },
};

const titleVariant = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.2,
      delay: 0.3,
      ease: "easeOut",
    },
  },
};

const Breadcrumb = ({
  title,
  bgImage,
}) => {
  return (
    <motion.section
      className="breadcrumb-section"
      style={{
        backgroundImage: `url(${bgImage})`,
      }}
      initial="hidden"
      animate="visible"
      variants={bannerVariant}
    >
      <div className="breadcrumb-overlay"></div>

      <div className="container breadcrumb-content">
        <motion.h1
          className="breadcrumb-title"
          variants={titleVariant}
        >
          {title}
        </motion.h1>
      </div>
    </motion.section>
  );
};

export default Breadcrumb;